/* Filtrous cart-drawer suggestions - v2.3, 2026-09-10 (Adelaide: the Phase 1
   "bundle suggestions before checkout" piece, built in-house - "no it has to
   be free").
   A "Complete your order" block between the drawer's line items and its
   foot, recomputed whenever the drawer repaints.
   v2.3 (Adelaide, 2026-09-10: "I should be able to hide it if I don't want
     to see it there"): a HIDE control. "Hide" sits next to the refresh
     button; the block collapses to a one-line strip - the heading plus
     "Show" - so it is out of the way but never lost. Remembered per browser
     in localStorage (key fv3-fcu-hidden), so it stays hidden across pages,
     drawer opens and visits until the customer clicks Show. Nothing else
     changes: pools, pages and quick view are untouched, and the block still
     disappears entirely when there is nothing to suggest. (The v1.2 Hide was
     session-scoped and removed in v1.3; this one is a different design.)
   v2 (Adelaide): REFRESH CYCLING + QUICK VIEW.
   - REFRESH ("an option to refresh... cycle through relevants... if a
     customer clicks infinitely it will recycle and scramble"): a quiet ↻
     button in the header deals the next page of candidates - the kit slot
     walks the whole price-anchored kit pool, the complement slots walk a
     family-ranked pool (up to 3 per family). When a full pass completes,
     the pool wraps around RE-SCRAMBLED (seeded by cart token x cycle
     number), so endless clicking endlessly recycles fresh arrangements.
     v2.1: the KIT pool re-scrambles on its own pass count too, so the lead
     card stops repeating the same price-ordered rotation; the block is a
     labeled region so the refreshed contents are navigable.
     The page index is remembered per cart in sessionStorage, so reopening
     the drawer shows the set the customer left off on (session-stability
     rule); a changed cart resets to page 0.
   - QUICK VIEW: opens the shared modal from assets/filtrous-quick-view.js.
     v2.2 (Adelaide: "i really like this quick view button... rather than an
     eye") - the eye icon button is gone; each row now carries a plain
     "Quick view" control under the price, matching the QUICK VIEW bar the
     PDP rail cards show on hover. Same data-fqv-handle contract.
   v1.3: the v1.2 session-scoped Hide control was removed same-day
   (Adelaide: "don't hide it actually").
   v1.1 (Adelaide: "that looks really ugly"): styled to the drawer's own
   design language - white ground, 48px thumbnails with the drawer's
   border/radius, .fcart-t-style two-line titles, "Full kit" as an inline
   chip, field-label heading, Add buttons in the drawer's teal.
   ALGORITHM (deterministic given cart + page: same cart at the same page
   always shows the same set):
   1. Read /cart.js; map lines to catalog-index records (handle, falling
      back to variant id). The system-managed Hazmat Fees line is ignored.
   2. KIT POOL: price-anchored kits from the UPSELL families of every cart
      line (closest above the top line's unit price first); empty when the
      cart already holds a kit-family item - you don't sell a second kit to
      someone who just bought one.
   3. COMPLEMENT POOL: WORKFLOW companions of every cart family, families
      ranked by COVERAGE, up to 3 cheapest in-stock items >= $5 per family.
      NEVER a family already in the cart (no alternatives), never an item
      already in the cart, never an OSK quote item.
   4. One-tap Add posts /cart/add.js and repaints via window.__fcartRefresh;
      the hazmat checkout guard still covers fee-tagged suggestions.
   Maps: window.FV3_MERCH (assets/filtrous-merch-maps.js, shared with the
   PDP rails). Index URL from this tag's data-index-url. Loaded (deferred)
   from snippets/filtrous-cart-drawer.liquid; remove those lines to revert. */
(function () {
  'use strict';
  if (window.__fcartUpsell) return;
  window.__fcartUpsell = true;

  var script = document.currentScript;
  var INDEX_URL = (script && script.getAttribute('data-index-url')) || (window.FV3_CONFIG && window.FV3_CONFIG.indexUrl) || '';
  var PAGE_KEY = 'fv3-fcu-page';
  var HIDE_KEY = 'fv3-fcu-hidden';   // v2.3: '1' while the customer has hidden the block

  /* styling lifted from the drawer's own stylesheet so the block reads as part of it */
  var css = document.createElement('style');
  css.textContent =
    '#fcart-upsell{flex:0 0 auto;border-top:1px solid #e3e9ee;padding:12px 20px 6px;background:#fff}' +
    '.fcu-head{display:flex;align-items:center;justify-content:space-between;gap:10px}' +
    '#fcart-upsell h4{margin:0;font-size:12px;font-weight:600;color:#5c6f7e}' +
    '.fcu-refresh{background:none;border:0;padding:2px;color:#5c6f7e;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;border-radius:6px}' +
    '.fcu-refresh:hover{color:#0d7d68;background:#f7fafb}' +
    '.fcu-refresh svg{display:block}' +
    /* v2.3: Hide / Show control, same look as the Quick view text control */
    '.fcu-ctrls{display:inline-flex;align-items:center;gap:12px}' +
    '.fcu-toggle{background:none;border:0;padding:0;font-family:inherit;font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#5c6f7e;cursor:pointer;white-space:nowrap;text-decoration:underline;text-underline-offset:2px;text-decoration-color:#c3cdd5}' +
    '.fcu-toggle:hover{color:#0d7d68;text-decoration-color:#0d7d68}' +
    '.fcu-toggle:focus-visible{outline:2px solid #0d7d68;outline-offset:2px;border-radius:3px}' +
    '#fcart-upsell.is-hidden{padding:10px 20px}' +
    '.fcu-row{display:flex;align-items:center;gap:10px;padding:12px 0;border-bottom:1px solid #eef3f6}' +
    '.fcu-row:last-child{border-bottom:0;padding-bottom:10px}' +
    '.fcu-row img{width:48px;height:48px;object-fit:contain;border:1px solid #eef3f6;border-radius:8px;background:#fff;flex:0 0 auto;display:block}' +
    '.fcu-noimg{width:48px;height:48px;border:1px solid #eef3f6;border-radius:8px;background:#f7fafb;flex:0 0 auto}' +
    '.fcu-info{flex:1 1 auto;min-width:0}' +
    '.fcu-t{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-size:13px;font-weight:600;line-height:1.35;color:#12222f;text-decoration:none}' +
    '.fcu-t:hover{color:#0d7d68}' +
    '.fcu-meta{display:flex;align-items:center;gap:8px;margin-top:4px}' +
    '.fcu-p{font-size:12.5px;font-weight:600;color:#0C2D4A;font-variant-numeric:tabular-nums}' +
    '.fcu-kit{background:#e5f9f4;color:#0d7d68;font-size:10.5px;font-weight:700;letter-spacing:.03em;padding:2px 8px;border-radius:999px;white-space:nowrap}' +
    /* v2.2: text control instead of the eye icon */
    '.fcu-qv{background:none;border:0;padding:0;font-family:inherit;font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#5c6f7e;cursor:pointer;white-space:nowrap;text-decoration:underline;text-underline-offset:2px;text-decoration-color:#c3cdd5}' +
    '.fcu-qv:hover{color:#0d7d68;text-decoration-color:#0d7d68}' +
    '.fcu-qv:focus-visible{outline:2px solid #0d7d68;outline-offset:2px;border-radius:3px}' +
    '.fcu-add{flex:0 0 auto;border:0;border-radius:7px;background:#20D5B3;color:#062334;font-size:12.5px;font-weight:700;padding:8px 14px;cursor:pointer;font-family:inherit}' +
    '.fcu-add:hover{background:#1bc4a4}' +
    '.fcu-add:disabled{background:#e3e9ee;color:#8496a3;cursor:default}' +
    '.fcu-add.done{background:#0d7d68;color:#fff}';
  document.head.appendChild(css);

  var byHandle = null, byVid = {};
  function loadIndex(cb) {
    if (byHandle) { cb(); return; }
    if (!INDEX_URL) { byHandle = {}; cb(); return; }
    fetch(INDEX_URL).then(function (r) { return r.json(); }).then(function (d) {
      byHandle = {};
      (d.products || []).forEach(function (p) {
        if (!p) return;
        if (p.handle && !byHandle[p.handle]) byHandle[p.handle] = p;
        if (p.vid) byVid[String(p.vid)] = p;
      });
      cb();
    }).catch(function () { byHandle = {}; cb(); });
  }

  function isQuote(sku) { return String(sku || '').toUpperCase().indexOf('OSK') !== -1; }
  function priceOf(it) { var n = parseFloat(it.price); return isFinite(n) ? n : 0; }
  function money(n) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function seededShuffle(arr, seedStr) {   // mulberry32 - presentation only
    var t = 0;
    for (var i = 0; i < seedStr.length; i++) t = (t * 31 + seedStr.charCodeAt(i)) | 0;
    t = t >>> 0;
    function rand() {
      t += 0x6D2B79F5;
      var r = Math.imul(t ^ t >>> 15, 1 | t);
      r = r + Math.imul(r ^ r >>> 7, 61 | r) ^ r;
      return ((r ^ r >>> 14) >>> 0) / 4294967296;
    }
    for (var j = arr.length - 1; j > 0; j--) {
      var k = Math.floor(rand() * (j + 1));
      var tmp = arr[j]; arr[j] = arr[k]; arr[k] = tmp;
    }
  }
  /* one pass through a pool = pool.length picks; later passes come back shuffled */
  function passOrder(list, taken, token, tag) {
    if (!list.length) return list;
    var cycle = Math.floor(taken / list.length);
    if (!cycle) return list;
    var out = list.slice();
    seededShuffle(out, token + '|' + tag + cycle);
    return out;
  }

  /* pools are deterministic given the cart; pages walk them */
  function buildPools(cart) {
    var M = window.FV3_MERCH;
    if (!M || !byHandle) return null;
    var inH = {}, inFam = {}, hasKit = false, lines = [];
    (cart.items || []).forEach(function (it) {
      if (String(it.sku || '').toUpperCase() === 'HAZMAT') return;
      if (it.handle) inH[it.handle] = 1;
      var p = byHandle[it.handle] || byVid[String(it.variant_id || it.id)];
      if (!p) return;
      inFam[p.primary_family] = 1;
      if (M.KIT_FAMS[p.primary_family]) hasKit = true;
      lines.push({ p: p, unit: it.final_price ? it.final_price / 100 : priceOf(p) });
    });
    if (!lines.length) return null;

    // kit pool: price-anchored to the priciest line, across ALL lines' upsell fams
    var kitPool = [];
    if (!hasKit) {
      lines.sort(function (a, b) { return b.unit - a.unit; });
      var kitFams = [], seenF = {};
      lines.forEach(function (l) {
        (M.UPSELL[l.p.primary_family] || []).forEach(function (f) {
          if (!seenF[f]) { seenF[f] = 1; kitFams.push(f); }
        });
      });
      if (kitFams.length) {
        var pool = [];
        for (var h in byHandle) {
          var it = byHandle[h];
          if (!it.available || inH[h] || isQuote(it.sku)) continue;
          if (kitFams.indexOf(it.primary_family) === -1) continue;
          pool.push(it);
        }
        var anchor = lines[0].unit;
        var above = pool.filter(function (x) { return priceOf(x) > anchor; }).sort(function (a, b) { return priceOf(a) - priceOf(b); });
        var below = pool.filter(function (x) { return priceOf(x) <= anchor; }).sort(function (a, b) { return priceOf(b) - priceOf(a); });
        kitPool = above.concat(below).slice(0, 8);
      }
    }

    // complement pool: coverage-ranked families, up to 3 cheapest (>= $5) each
    var score = {}, ord = {}, oi = 0;
    Object.keys(inFam).forEach(function (f) {
      (M.WORKFLOW[f] || []).forEach(function (cf) {
        if (inFam[cf]) return;
        if (!(cf in score)) { score[cf] = 0; ord[cf] = oi++; }
        score[cf]++;
      });
    });
    var ranked = Object.keys(score).sort(function (a, b) { return score[b] - score[a] || ord[a] - ord[b]; });
    var compPool = [];
    ranked.forEach(function (fam) {
      var famItems = [];
      for (var h2 in byHandle) {
        var c = byHandle[h2];
        if (!c.available || inH[h2] || isQuote(c.sku)) continue;
        if (c.primary_family !== fam) continue;
        if (priceOf(c) < 5) continue;
        famItems.push(c);
      }
      famItems.sort(function (a, b) { return priceOf(a) - priceOf(b); });
      compPool = compPool.concat(famItems.slice(0, 3));
    });
    compPool = compPool.slice(0, 24);
    return { kitPool: kitPool, compPool: compPool };
  }

  /* page k: one kit (walking the kit pool) + complements walking the comp
     pool; each completed pass through either pool re-scrambles that pool
     (seeded by cart token x pass number) - infinite clicking recycles fresh
     arrangements instead of looping the same rotation */
  function selectPage(pools, token, page) {
    var M = window.FV3_MERCH;
    var picks = [];
    var kit = null;
    if (pools.kitPool.length) {
      var kitOrder = passOrder(pools.kitPool, page, token, 'kit');
      kit = kitOrder[page % kitOrder.length];
      picks.push({ it: kit, kit: !!(M && M.KIT_FAMS[kit.primary_family]) });
    }
    var list = pools.compPool;
    if (list.length) {
      var need = kit ? 2 : 3;
      var ordered = passOrder(list, page * need, token, 'cycle');
      var start = (page * need) % ordered.length;
      var famUsed = {}, handleUsed = {};
      if (kit) { famUsed[kit.primary_family] = 1; handleUsed[kit.handle] = 1; }
      for (var i = 0; i < ordered.length && picks.length < 3; i++) {
        var c = ordered[(start + i) % ordered.length];
        if (handleUsed[c.handle] || famUsed[c.primary_family]) continue;
        handleUsed[c.handle] = 1;
        famUsed[c.primary_family] = 1;
        picks.push({ it: c, kit: false });
      }
    }
    return picks;
  }

  var pageState = { token: null, page: 0 };
  function restorePage(token) {
    if (pageState.token === token) return;
    pageState.token = token;
    pageState.page = 0;
    try {
      var s = JSON.parse(sessionStorage.getItem(PAGE_KEY) || 'null');
      if (s && s.t === token) pageState.page = s.p | 0;
    } catch (e) {}
  }
  function savePage() {
    try { sessionStorage.setItem(PAGE_KEY, JSON.stringify({ t: pageState.token, p: pageState.page })); } catch (e) {}
  }

  /* v2.3: hidden state, per browser. Reads fail closed to "shown". */
  function isHidden() {
    try { return localStorage.getItem(HIDE_KEY) === '1'; } catch (e) { return false; }
  }
  function setHidden(on) {
    try { if (on) localStorage.setItem(HIDE_KEY, '1'); else localStorage.removeItem(HIDE_KEY); } catch (e) {}
  }
  function focusToggle() {
    var t = document.querySelector('.fcu-toggle');
    if (t) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }
  }
  function toggleBtn(hiddenNow) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fcu-toggle';
    b.textContent = hiddenNow ? 'Show' : 'Hide';
    b.setAttribute('aria-label', hiddenNow ? 'Show suggestions' : 'Hide suggestions');
    b.setAttribute('aria-expanded', hiddenNow ? 'false' : 'true');
    b.addEventListener('click', function () {
      setHidden(!hiddenNow);
      lastKey = null;                 // force a repaint of the same cart
      if (lastCart) paint(lastCart);
      focusToggle();
    });
    return b;
  }

  function refreshSvg() {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('width', '15'); s.setAttribute('height', '15');
    s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor'); s.setAttribute('stroke-width', '2');
    s.setAttribute('stroke-linecap', 'round'); s.setAttribute('stroke-linejoin', 'round'); s.setAttribute('aria-hidden', 'true');
    s.innerHTML = '<polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>';
    return s;
  }

  var lastKey = null;
  var lastCart = null;
  function paint(cart) {
    lastCart = cart;
    var drawer = document.getElementById('fcart');
    if (!drawer) return;
    var foot = drawer.querySelector('.fcart-foot');
    if (!foot) return;
    var token = (cart.items || []).map(function (it) { return it.handle + ':' + it.quantity; }).join('|');
    restorePage(token);
    var hidden = isHidden();
    var key = token + '#' + pageState.page + (hidden ? '#h' : '');
    var block = document.getElementById('fcart-upsell');
    if (key === lastKey && block) return;   // same cart + page -> same block
    lastKey = key;
    var pools = buildPools(cart);
    var picks = pools ? selectPage(pools, token, pageState.page) : [];
    if (!picks.length) { if (block) block.remove(); return; }
    var canCycle = pools && (pools.kitPool.length + pools.compPool.length) > picks.length;
    if (!block) {
      block = document.createElement('div');
      block.id = 'fcart-upsell';
      block.setAttribute('role', 'region');
      block.setAttribute('aria-label', 'Complete your order');
      foot.parentNode.insertBefore(block, foot);
    }
    block.innerHTML = '';
    var head = document.createElement('div');
    head.className = 'fcu-head';
    var h = document.createElement('h4');
    h.textContent = 'Complete your order';
    head.appendChild(h);
    block.classList.toggle('is-hidden', hidden);
    if (hidden) {
      /* v2.3: collapsed strip - heading + Show, no rows */
      head.appendChild(toggleBtn(true));
      block.appendChild(head);
      return;
    }
    var ctrls = document.createElement('div');
    ctrls.className = 'fcu-ctrls';
    if (canCycle) {
      var rf = document.createElement('button');
      rf.type = 'button';
      rf.className = 'fcu-refresh';
      rf.setAttribute('aria-label', 'Show different suggestions');
      rf.appendChild(refreshSvg());
      rf.addEventListener('click', function () {
        pageState.page++;
        savePage();
        if (lastCart) paint(lastCart);
        var again = document.querySelector('.fcu-refresh');
        if (again) { try { again.focus({ preventScroll: true }); } catch (e) { again.focus(); } }
      });
      ctrls.appendChild(rf);
    }
    ctrls.appendChild(toggleBtn(false));
    head.appendChild(ctrls);
    block.appendChild(head);
    picks.forEach(function (pk) {
      var it = pk.it;
      var row = document.createElement('div');
      row.className = 'fcu-row';
      if (it.image) {
        var img = document.createElement('img');
        img.src = it.image;
        img.alt = '';
        img.loading = 'lazy';
        row.appendChild(img);
      } else {
        var ph = document.createElement('span');
        ph.className = 'fcu-noimg';
        ph.setAttribute('aria-hidden', 'true');
        row.appendChild(ph);
      }
      var info = document.createElement('div');
      info.className = 'fcu-info';
      var a = document.createElement('a');
      a.className = 'fcu-t';
      a.href = '/products/' + it.handle;
      a.textContent = it.title;
      info.appendChild(a);
      var meta = document.createElement('div');
      meta.className = 'fcu-meta';
      var p = document.createElement('span');
      p.className = 'fcu-p';
      p.textContent = money(priceOf(it));
      meta.appendChild(p);
      if (pk.kit) {
        var kb = document.createElement('span');
        kb.className = 'fcu-kit';
        kb.textContent = 'Full kit';
        meta.appendChild(kb);
      }
      var qv = document.createElement('button');   // v2.2: text control, no eye
      qv.type = 'button';
      qv.className = 'fcu-qv';
      qv.textContent = 'Quick view';
      qv.setAttribute('data-fqv-handle', it.handle);
      qv.setAttribute('aria-label', 'Quick view: ' + it.title);
      meta.appendChild(qv);
      info.appendChild(meta);
      row.appendChild(info);
      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'fcu-add';
      add.textContent = 'Add';
      add.addEventListener('click', function () {
        if (!it.vid) { window.location.href = '/products/' + it.handle; return; }
        add.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(it.vid), quantity: 1 })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          add.classList.add('done');
          add.textContent = '✓';
          if (window.__fcartRefresh) window.__fcartRefresh();
        }).catch(function () {
          add.textContent = 'Retry';
          add.disabled = false;
        });
      });
      row.appendChild(add);
      block.appendChild(row);
    });
  }

  var pending = false;
  function recompute() {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      loadIndex(function () {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(paint).catch(function () {});
      });
    }, 150);
  }

  function armLines() {
    var lines = document.getElementById('fcart-lines');
    if (!lines || lines.getAttribute('data-fcu')) return !!lines;
    lines.setAttribute('data-fcu', '1');
    try { new MutationObserver(recompute).observe(lines, { childList: true }); } catch (e) {}
    recompute();
    return true;
  }
  function boot() {
    if (armLines()) return;
    var mo = new MutationObserver(function () { if (armLines()) mo.disconnect(); });
    try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
